import doubleSharpAsset from 'assets/images/notation/double_sharp.svg?url&no-inline';

/**
 * An address the scene loader fetches as it stands. The loader puts the asset
 * host's path in front of any address that does not start with a scheme, so one
 * that starts at the root of the app's own build is made whole first, against
 * the page's address: the site on the web, the app's local origin on a device.
 */
export const absoluteAssetUrl = (assetUrl: string, pageUrl: string): string =>
  new URL(assetUrl, pageUrl).href;

/**
 * Where the double sharp is loaded from: the app's own build, unlike the other
 * staff glyphs, which come from the asset host (MUS-624).
 */
export const doubleSharpUrl = (): string => absoluteAssetUrl(doubleSharpAsset, document.baseURI);
